<template>
  <div id="user">
    <cachalog-image-capture></cachalog-image-capture>
    <h1 class="has-text-centered has-text-weight-bold is-c-text is-cs-2">アカウント管理</h1>
    <div v-if="image">
      <figure class="user-circle image is-128x128">
        <cachalog-img :type="'background'" class="is-rounded" :caption="image.caption"
          :full-path="image.full_path" :source="image.source" :edit="true"></cachalog-img>
        <span class="camera-icon" @click="takePicture">
          <i class="c-icon cachalog-camera">
            <span class="path1"></span><span class="path2"></span>
          </i>
        </span>
      </figure>
    </div>
    <div class="form">
      <div v-if="user.email">
        <label>メール</label>
        <span class="email has-text-weight-bold">{{ user.email }}</span>
      </div>
      <div>
        <label for="form-nickname">名前</label>
        <input type="text" name="nickname" id="form-nickname" placeholder="必須項目です" v-model="nickname" />
        <p class="notice is-c-alert-text has-text-centered" v-if="!validNickname && nickname">30文字以内で入力してください。</p>
      </div>
      <!--<div>
        <label for="form-birthday">生年月日</label><br>
        <input type="date" name="birthday" id="form-birthday" v-model="birthday" />
      </div>-->
      <div class="account">
        <label>連携</label>
        <span class="icon">
          <i :class="snsIconClasses[user.provider]"></i>
        </span>
        <span>{{ providerData.displayName }}</span>
      </div>
    </div>
    <div>
      <div class="has-text-centered">
        <button class="button is-rounded is-c-primary is-large is-cs-4" :disabled="!validNickname" @click="updateAccount">保存</button>
      </div>
      <template v-if="user.nickname">
        <hr>
        <div class="has-text-centered">
          <button class="button is-rounded is-c-operation is-large is-cs-4" @click="signOut">ログアウト</button>
        </div>
        <div class="has-text-centered" v-if="false">
          <!--<button class="button is-rounded is-c-alert is-large is-cs-4" @click="closedAccount">アカウントの削除</button>-->
          <button class="button is-rounded is-c-alert is-large is-cs-4" @click="modal = true">アカウントの削除</button>
        </div>
      </template>
    </div>
    <div class="modal" style="margin: 0;" :class="{'is-active': modal}">
      <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
          <p>ユーザ確認のためにパスワードを入力してください。</p>
          <p>{{ user.email }}</p>
          <form v-on:submit.prevent="closeAccount">
            <input type="password" v-model="password">
            <input type="submit" value="送信">
          </form>
        </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
    <c-footer></c-footer>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { fb, db, mixin, indexOf, incrementCounter } from './common.js'
import imageCapture from './image-capture.js'
import cFooter from './view/c-footer.vue'
export default {
  components: {
    'cachalog-image-capture': imageCapture,
    'c-footer': cFooter
  },
  mixins: [mixin],
  data: () => ({
    imagePosition: 'user-image',
    temp: {
      nickname: '',
      birthday: '',
      image: null
    },
    password: '',
    modal: false
  }),
  computed: {
    ...Vuex.mapState({
      providerData: 'providerData',
      user: 'user',
      anonymous: 'anonymous',
      snsIconClasses: 'snsIconClasses',
      imageSourceQueue: 'imageSourceQueue'
    }),
    nickname: {
      get () {
        return this.temp.nickname || this.user.nickname
      },
      set (value) {
        this.temp.nickname = value
      }
    },
    validNickname () {
      return this.nickname && this.nickname.length <= 30
    },
    birthday: {
      get () {
        return this.temp.birthday || this.user.birthday
      },
      set (value) {
        this.temp.birthday = value
      }
    },
    image () {
      return (this.temp.image) ||
        (this.user.images && this.user.images[0]) ||
        {}
    },
    isOwner () {
      return this.user.pages && this.user.pages.length
    }
  },
  watch: {
    imageSourceQueue (value) {
      const index = indexOf(value, 'position', this.imagePosition)
      if (index !== false) {
        this.temp.image = value[index]
        this.$store.commit('dequeueImageSource')
        incrementCounter(db.doc('users/' + this.user.uid), 'images_counter')
          .then(n => (this.temp.image.id = n))
          .catch(error => console.error(error))
      }
    }
  },
  methods: {
    takePicture () {
      this.$store.commit('storeImagePosition', this.imagePosition)
      document.querySelector('#image-capture input').click()
    },
    signOut () {
      this.$store.dispatch('signOut')
    },
    updateAccount () {
      this.$store.dispatch('updateUserProfile', this.temp)
    },
    closeModal () {
      this.modal = false
      this.password = ''
    },
    closeAccount () {
      const user = fb.auth().currentUser
      const credential = fb.auth.EmailAuthProvider.credential(
        user.email,
        this.password
      )
      user.reauthenticateWithCredential(credential)
        .then(() => {
          console.log('reauthenticate')
          if (confirm('アカウントを削除します。よろしいですか？')) {
            if (!this.isOwner || confirm('あなたが管理しているショップも削除されます。よろしいですか？')) {
              this.modal = false
              this.password = ''
              this.$store.dispatch('closeAccount')
            }
          }
        })
        .catch(error => {
          console.error(error)
          alert('パスワードが違います。')
        })
        .finally(() => {
        })
    }
  },
  created () {
    if (!this.user.uid) {
      this.$router.push({name: 'sign-in'})
    } else if (this.anonymous) {
      this.$router.push({name: 'mypage'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account.vue